module.exports = __webpack_public_path__ + "static/html-ac6d5c03e3f070aa8b55e2cd55246af1.png";